import { BASE_URL_ML } from "../../utils/constants";

/**
 * Stream AI query via SSE
 */
export const streamAIQuery = (
  query,
  schema,
  sessionId,
  userId,
  { onToken, onComplete, onError }
) => {
  const controller = new AbortController();

  (async () => {
    try {
      const res = await fetch(`${BASE_URL_ML}/mcp/query/stream`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          schema,
          session_id: sessionId,
          user_id: String(userId),
        }),
        signal: controller.signal,
      });

      if (!res.ok) {
        const errorBody = await res.json().catch(() => ({}));
        const errorMessage = errorBody.detail || `AI API error: ${res.status}`;
        const error = new Error(errorMessage);
        error.status = res.status;
        error.details = errorBody;
        throw error;
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        const lines = buffer.split("\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          if (!line.startsWith("data:")) continue;

          const json = line.replace("data:", "").trim();
          if (!json) continue;

          try {
            const parsed = JSON.parse(json);

            if (parsed.event === "result_stream") {
              // normalize token: convert escaped "\\n" sequences to actual newlines
              let token = parsed.data?.token ?? "";
              if (typeof token === "string") {
                token = token.replace(/\\n/g, "\n");
              }
              onToken?.(token);
            }

            if (parsed.event === "complete") {
              onComplete?.();
            }
          } catch (err) {
            console.warn("Stream parse error:", err);
          }
        }
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        onError?.(err);
      }
    }
  })();

  return () => controller.abort();
};

/**
 * Generate new session per account
 */
export const generateSessionId = (accountId = "all") =>
  `session_${accountId}_${Date.now()}`;

/**
 * Map account to schema
 */
export const getSchemaFromAccount = (account) => {
  if (!account || account.scope === "all") {
    return "global";
  }

  return account.scope;
  
};
